import React from 'react'
import {useHistory} from 'react-router-dom'
import './BannerMedicalFinderToday.css'

/* imgs */
import BannerFinderTDesk from '../../assets/img/banner-finder-medication-desk.svg'
import BannerFinderTTablet from '../../assets/img/banner-finder-medication-tablet.svg'
import BannerFinderTMobile from '../../assets/img/banner-finder-medication-mobile.svg'
import IcBtnFinderPrice from '../../assets/img/ic_buscar_precios_btn.svg'
import IcBtnFinderFile from '../../assets/img/ic_buscar_una_ficha.svg'
import {logEvent} from '../../Utils/utils'

function BannerMedicalFinderToday(props) {
  const goToPage = (url) => {
    switch (url) {
      case '/pro/medication-sheet':
        logEvent('Medication Sheet Opened')
        break
      case '/pro/price_finder':
        logEvent('Price Finder Opened')
        break
      default:
        break
    }
    props.goTo(url)
  }

  return (
    <div className="banner-finder-today">
      <picture>
        <source media="(max-width: 610px)" srcSet={BannerFinderTMobile} />
        <source media="(max-width: 991px)" srcSet={BannerFinderTTablet} />
        <source media="(min-width: 992px)" srcSet={BannerFinderTDesk} />
        <img
          src={BannerFinderTDesk}
          alt="banner"
          className="banner-finder-today-img w-100"
        />
      </picture>
      <div className="content-text-finder-today">
        <div className="banner-finder-today-header">
          <h3 className="txt-1--bold-li text-header">
            ¿Qué medicamento estás buscando hoy?
          </h3>
        </div>
        <div className="banner-finder-today-body justify-content-center p-md-0">
          <div
            id="gtm-webpro-goto-medication-sheet"
            className="btn-icon-finder-today c-pointer"
            onClick={() => goToPage('/pro/medication-sheet')}>
            <div className="d-flex w-100">
              <img
                className="icon-btn-left"
                src={IcBtnFinderFile}
                alt="Información de Medicamentos"
              />
              <div className="mr-3">
                <h3 className="txt-4--bold m-0 text-nowrap">
                  Información de Medicamentos
                </h3>
              </div>
            </div>
            <div className="icon-btn">
              <i className="icon-chevron-right"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BannerMedicalFinderToday
